import { useEffect, useState } from 'react'

/**
 * Returns the current viewport width and height in pixels
 *
 * This is a hook that returns the current viewport width and height in pixels.
 * It is used to determine the current viewport size and to determine if the viewport is mobile, tablet, or desktop based on component's breakpoints.
 *
 * @returns {width: number, height: number} The current viewport width and height in pixels
 */
export const useViewportSizeInPixels = (): { width: number; height: number } => {
  const [width, setWidth] = useState(window.innerWidth)
  const [height, setHeight] = useState(window.innerHeight)

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return { width, height }
}
